import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { CloseCardButton } from "@/uiKit/atoms/CloseCardButton.tsx";
import { StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";
import { InclusionCenterCardContent } from "@/uiKit/organisms/InclusionCenter/InclusionCenterCardContent.tsx";

export type InclusionAgentProps = {
  onClose?: () => void;
  className?: string;
  classes?: StyleClasses<"root" | "header" | "content">;
};

export const InclusionCenterCard: React.FC<InclusionAgentProps> = ({ onClose, className, classes }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Card id="inclusion-panel" className={cx(styles.root, className, classes?.root)}>
      {onClose && <CloseCardButton onClick={onClose} />}
      <CardHeader
        id="inclusion-agent-header"
        title={t("inclusionAgent.title")}
        variant="plain"
        className={cx(styles.header, classes?.header)}
      />
      <CardContent className={cx(styles.content, classes?.content)}>
        <InclusionCenterCardContent onClose={onClose} />
      </CardContent>
      <CardFooter />
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    position: "relative",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  header: css({
    "> *": {
      textAlign: "center",
    },
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    gap: theme.spacing(8),
  }),
  closeIcon: css({
    width: FontSizes.caption,
    height: FontSizes.caption,
    color: theme.palette.grey[400],
  }),
});
